/**
 * @Author: zachalam
 * @Date:   2017-03-15T16:16:14-07:00
 * @Email:  zach@reflexmedia.com
 * @Last modified by:   hiral
 * @Last modified time: 2024-07-17T17:30:31-07:00
 */

import React, { ReactElement } from 'react';
import BlockedDismissed from '../components/pages/Settings/BlockedDismissed';

const BlockedContainer = (): ReactElement => {
  return <BlockedDismissed />;
};

export default BlockedContainer;
